module.exports = __webpack_public_path__ + "16b4dd3bf9f1f0d43dd197f98ea5ffc5.svg";